/* eslint-disable @next/next/no-html-link-for-pages */
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type BreadCrumbUrl = {
  text?: string;
  url?: string;
};

type Props = {
  urls: BreadCrumbUrl[];
  className?: string;
};

const RenderUrl = ({
  text,
  url = undefined,
  firstUrl = false,
}: {
  text: string;
  url?: string;
  firstUrl?: boolean;
}) => (
  <li className="flex">
    <Typography variant="body2">
      {!firstUrl && <>/ </>}
      {url ? (
        <a className="text-green-50 hover:text-green-60" href={url}>
          {text}
        </a>
      ) : (
        <>{text}</>
      )}
    </Typography>
  </li>
);

export const BreadCrumb: FC<Props> = ({ urls, className = '' }) => {
  return (
    <ol className={twMerge('flex flex-wrap space-x-2', className)}>
      <RenderUrl firstUrl text="Home" url="/" />
      <RenderUrl
        text="Plat Map"
        url={urls.length > 0 ? '/plat-map/map' : undefined}
      />

      {urls.map((url) => {
        if (!url.text) return null;
        return (
          <div key={url.text}>
            <RenderUrl text={url.text} url={url.url} />
          </div>
        );
      })}
    </ol>
  );
};
